export default "__VITE_ASSET__Fbb8h1Ib__"